<template>
  <div class="page-login">
    <div class="left" ref="animate">
      <svg-icon icon-class="login-logo" class-name="logo"></svg-icon>
    </div>
    <div class="right">
      <div class="right-container">
        <!-- 登录 -->
        <div v-show="isShowLogin" class="login-container">
          <div class="login-type login-title">
            <div>{{$t('login.LoginWithPassword')}}</div>
            <a-select :default-value="language" @change="handleChangeLanguage">
              <a-select-option :value="LANGUAGE.ENGLISH">English</a-select-option>
              <a-select-option :value="LANGUAGE.CHINESE">简体中文</a-select-option>
            </a-select>
          </div>
          <a-form class="form-container" :form="form" >
            <a-form-item :validate-status="accountSts" :help="accountHelp">
              <a-input
                :placeholder="$t('login.phoneUserEmail')"
                v-model="account"
                @focus="initValidate('account')"
                autoFocus
              />
            </a-form-item>
            <a-form-item class="pwd-container" :validate-status="pwdSts" :help="pwdHelp">
              <a-input-password
                class="pwd"
                :placeholder="$t('login.Password')"
                v-model="password"
                @focus="initValidate('pwd')"
              />
            </a-form-item>
            <a-form-model-item class="privacy-container" prop="privacy">
              <a-checkbox v-model="privacy">
                {{$t('login.ReadAgreed')}}
              </a-checkbox>

              <a href="./protocol/service" target="_blank"
                style="color: #236CFF;font-weight: 500">{{$t('login.UserServiceAgreement')}}</a>
              {{$t('login.and')}}
              <a href="./protocol/privacy" target="_blank"
                style="color: #236CFF;font-weight: 500">{{$t('login.PrivacyPolicy')}}</a>

            </a-form-model-item>
            <a-form-item class="login-btn-container">
              <a-button
                class="common-btn login-btn"
                type="primary"
                @click="handleSubmit"
                :disabled="disabled"
              >
                {{$t('login.LogIn')}}
              </a-button>
            </a-form-item>
          </a-form>
          <div class="account-control">
            <span class="to-register-btn" @click="showRegister">{{$t('login.Registration')}}</span>
            <span class="to-forgotpw-btn" @click="showForgotpw">{{$t('forgot.ForgotPassword')}}</span>
          </div>
          <a-divider class="divider">{{$t('login.ThirdPartyLogin')}}</a-divider>
          <div class="other-login">
            <template v-for="party in oauthThirdParty">
              <Tooltip
                overlay-class-name="tooltip-no-arrow"
                :key="party.id"
                placement="bottom"
                :title="party.name"
                :align="{ offset: [0, -2] }"
              >
                <div
                  class="oauth-item"
                  :style="getBackground(party.logo)"
                  @click="handleToOauth(party.url)"
                ></div>
              </Tooltip>
            </template>
          </div>
        </div>
        <!-- 注册 -->
        <div v-show="registerVisible" class="common-container register-container">
          <div class="main-title center">
            <div>{{$t('login.Registration')}}</div>
          </div>
          <a-form-model ref="registerForm" class="form-container" :model="registerForm" :rules="registerRules" v-bind="registerLayout">
            <a-form-model-item prop="account">
              <a-input
                :placeholder="$t('register.EnterYourPhoneMumber')"
                v-model="registerForm.account"
                @change="accountError = ''"
                autoFocus
                autocomplete="new-password"
              />
            </a-form-model-item>

            <a-form-model-item class="code-container" prop="code">
              <a-input
                :style="{width: $i18n.locale === LANGUAGE.CHINESE ? '200px': '180px'}"
                :placeholder="$t('register.EnterVerificationCode')"
                v-model="registerForm.code"
                @change="codeError = ''"
                autocomplete="new-password"
              />

              <div class="code-operation">
                <a-button v-show="codeButtonVisible" :style="{width: $i18n.locale === LANGUAGE.CHINESE ? '144px': '160px'}" type="primary" class="common-btn code-btn" @click="beforeGetImageCode('registerForm')">{{$t('register.GetVerificationCode')}}</a-button>

                <div v-show="!codeButtonVisible" class="code-tip">
                  <span class="countdown">{{ codeRestSecond }} {{$t('login.Second')}} </span><span>{{$t('register.Reacquire')}}</span>
                </div>
              </div>
            </a-form-model-item>

            <a-form-model-item prop="password">
              <a-input-password
                :placeholder="$t('register.EnterPassword')"
                v-model="registerForm.password"
                autocomplete="new-password"
              />
            </a-form-model-item>

            <a-form-model-item prop="checkPassword">
              <a-input-password
                :placeholder="$t('register.ConfirmPassword')"
                v-model="registerForm.checkPassword"
                autocomplete="new-password"
              />
            </a-form-model-item>

            <a-form-model-item class="user-name-container" prop="userName">
              <a-input
                :placeholder="$t('register.EnterUsername')"
                v-model="registerForm.userName"
                @change="userNameError = ''"
                autocomplete="new-password"
              />
            </a-form-model-item>

            <a-form-model-item class="privacy-container" prop="privacy">
              <a-checkbox v-model="registerForm.privacy">
                {{$t('register.MeansAgreeingAgreement')}}
              </a-checkbox>

              <a href="https://www.hiar.com/protocol/hileia-privacy" target="_blank"
                style="color: #236CFF;font-weight: 500">{{$t('login.UserServiceAgreement')}}</a>

              <span class="to-login-btn" @click="showLogin">{{$t('register.Back')}}</span>
            </a-form-model-item>

            <a-form-item>
              <a-button
                class="common-btn register-btn"
                type="primary"
                @click="submitRegister"
                :disabled="canRegister"
              >
                {{$t('register.SignUp')}}
              </a-button>
            </a-form-item>
          </a-form-model>
        </div>
        <!-- 忘记密码 -->
        <div v-show="forgotpwVisible" class="common-container forgotpw-container">
          <div class="main-title">
            <div>{{$t('forgot.EnterPhoneNumber')}}</div>
          </div>
          <a-form-model ref="forgotpwForm" class="form-container" :model="forgotpwForm" :rules="forgotpwRules" v-bind="registerLayout">
            <a-form-model-item prop="account">
              <a-input
                :placeholder="$t('register.EnterYourPhoneMumber')"
                v-model="forgotpwForm.account"
                @change="accountError = ''"
                autoFocus
                autocomplete="new-password" />
              <span v-show="accountError" class="info-error">{{ accountError }}</span>
            </a-form-model-item>
            <a-form-model-item class="code-container" prop="code">
              <a-input
                :style="{width: $i18n.locale === LANGUAGE.CHINESE ? '200px': '180px'}"
                :placeholder="$t('register.EnterVerificationCode')"
                v-model="forgotpwForm.code"
                @change="codeError = ''"
                autocomplete="new-password"/>
              <div class="code-operation">
                <!-- <a-button v-show="codeButtonVisible" :style="{width: $i18n.locale === LANGUAGE.CHINESE ? '144px': '160px'}" type="primary" class="common-btn code-btn" @click="beforeGetImageCode('forgotpwForm')">{{$t('register.GetVerificationCode')}}</a-button> -->
                <a-button v-show="codeButtonVisible" :style="{width: $i18n.locale === LANGUAGE.CHINESE ? '144px': '160px'}" type="primary" class="common-btn code-btn" @click="getCodeOfRestpw">{{$t('register.GetVerificationCode')}}</a-button>
                <div v-show="!codeButtonVisible" class="code-tip">
                  <span class="countdown">{{ codeRestSecond }} {{$t('login.Second')}} </span><span>{{$t('register.Reacquire')}}</span>
                </div>
              </div>
            </a-form-model-item>
            <a-form-item>
              <span class="position" :style="{width: $i18n.locale === LANGUAGE.CHINESE ? '200px': '180px'}">
                <a-button
                  class="common-btn forgotpw-cancel-btn"
                  @click="showLogin">{{$t('common.Cancel')}}</a-button>
              </span>
              <div class="code-operation">
                <a-button
                  :style="{width: $i18n.locale === LANGUAGE.CHINESE ? '144px': '160px'}"
                  class="common-btn forgotpw-btn"
                  type="primary"
                  @click="submitForgotpw"
                  :disabled="canForgotpw">{{$t('common.Next')}}</a-button>
              </div>
            </a-form-item>
          </a-form-model>
        </div>
        <!-- 设置新密码 -->
        <div v-show="restpwVisible" class="common-container restpw-container">
          <div class="main-title">
            <div>{{$t('forgot.SetNewPassword')}}</div>
          </div>
          <a-form-model ref="restpwForm" class="form-container" :model="restpwForm" :rules="restpwRules" v-bind="registerLayout">
            <a-form-model-item prop="password">
              <a-input-password
                :placeholder="$t('register.EnterPassword')"
                v-model="restpwForm.password"
                autocomplete="new-password"
              />
            </a-form-model-item>

            <a-form-model-item prop="checkPassword">
              <a-input-password
                :placeholder="$t('register.ConfirmPassword')"
                v-model="restpwForm.checkPassword"
                autocomplete="new-password"
              />
            </a-form-model-item>
            <a-form-item>
              <a-button
                class="common-btn"
                type="primary"
                @click="submitRestpw"
                :disabled="canRestpw">{{$t('common.Ok')}}</a-button>
            </a-form-item>
          </a-form-model>
        </div>
      </div>
    </div>
    <OauthGroup
      :oauthSuccess="handleOauthSuccess"
    />

    <a-modal
      :visible="imageCodeModalVisible"
      :closable="false"
      :maskClosable="false"
      :keyboard="false"
      :width="460"
      :footer="null"
      :getContainer="modalContainer"
      centered
      class="image-code-modal two-buttons-one-close-confirm-modal"
    >
      <section class="custom-content">
        <h2>{{$t('register.VerificationCode')}}</h2>
        <i @click="imageCodeModalVisible = false"></i>

        <div class="image-code-container">
          <a-input
            class="image-code-input"
            :placeholder="$t('register.EnterVerificationCode1')"
            v-model="imageCode"
          />

          <div class="image-container">
            <img v-show="!!imageCodeUrl" :src="imageCodeUrl" class="image-code" alt="">
          </div>

          <span class="next-image" @click="getImageCode">{{$t('register.ChangeOne')}}</span>

          <span v-show="imageError" class="image-error">{{ imageError }}</span>
        </div>

        <a-button type="primary" class="common-btn image-confirm-btn" @click="getCode" :disabled="!imageCode">{{$t('common.Ok')}}</a-button>
      </section>
    </a-modal>

    <a-modal
      :visible="registerSuccessVisible"
      :closable="false"
      :maskClosable="false"
      :keyboard="false"
      :width="460"
      :footer="null"
      :getContainer="modalContainer"
      :maskStyle="{backgroundColor: 'rgba(10, 15, 26, 0.1)'}"
      centered
      class="image-success-modal two-buttons-one-close-confirm-modal"
    >
      <section class="custom-content">
        <h2>{{$t('login.RegisterSucc')}}</h2>

        <div class="tip">
          <span class="seconds">{{ successRestSecond }} </span>{{$t('common.Second')}} <span class="return" @click="fromSuccessToLogin">{{$t('register.Back')}}</span>
        </div>
      </section>
    </a-modal>

    <a-modal
      :visible="restpwSuccessVisible"
      :closable="false"
      :maskClosable="false"
      :keyboard="false"
      :width="460"
      :footer="null"
      :getContainer="modalContainer"
      :maskStyle="{backgroundColor: 'rgba(10, 15, 26, 0.1)'}"
      centered
      class="image-success-modal passwd-rest-succ"
    >
      <section class="custom-content">
        <svg-icon icon-class="appoint-scs"></svg-icon>
        <span>{{$t('forgot.SetPasswordSucc')}}</span>
      </section>
    </a-modal>
  </div>
</template>

<script>
import lottie from 'lottie-web'
import { Tooltip } from 'ant-design-vue'
import { OauthGroup } from '@/components/business/oauth/index'
import {
  mapActions,
  // mapState
} from 'vuex'
// import router from '@/router'
import MD5 from 'crypto-js/md5'
import { CACHE_KEY, PAGE_NAME, ONE_DAY_MILLSECS, LANGUAGE } from '@/utils/constant'
import { apis, getRegisterCode, registerAccount, getRestpwCode, restpwCodeKey, resetpw } from '@/api/user'

import axios from 'axios'
// import Global from '@/global'
// const Qs = require('qs')

let codeCountDownInterval
let successCountDownInterval

/**
 * 进入login页面，需要判断route.query的参数
 * use=auth&factory=&token=xxxx&users=
 * {
 *  use: 'oauth', //用途或来源, oauth授权后进入
 *  factory: 'feiiplat', //提供授权的厂家
 *  token: 'xxx', //服务端产生的token, 用于登录
 *  users: 'xxx' //utf-8的base64， 需要使用Global.
 * }
 */

export default {
  name: 'Login',
  components: {
    Tooltip,
    OauthGroup
  },
  data() {
    // 自定义校验手机号，主要是把提示改成服务端的报错
    const validateAccount = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('login.EnterPhoneNumber')))
      } else if (this.accountError) {
        callback(new Error(this.accountError))
      } else {
        callback()
      }
    }

    // 自定义校验姓名，主要是把提示改成服务端的报错
    const validateUserName = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('register.EnterUsername')))
      } else if (this.userNameError) {
        callback(new Error(this.userNameError))
      } else {
        const length = String(value).length
        const first = value[0]
        const last = value[length - 1]
        if (/\s/.test(first) || /\s/.test(last)) {
          callback(new Error(this.$t('register.NameNotSpace')))
        } else {
          const trimLength = String(value).trim().length
          if (trimLength < 2) {
            callback(new Error(this.$t('home.Less2CharOfName')))
          } else if (trimLength > 16) {
            callback(new Error(this.$t('register.NameMore16Char')))
          } else {
            callback()
          }
        }
      }
    }

    // 自定义校验验证码，主要是把提示改成服务端的报错
    const validateCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('register.EnterVerificationCode')))
      } else if (this.codeError) {
        callback(new Error(this.codeError))
      } else {
        callback()
      }
    }

    // 校验密码是否一致
    const validateCheckPassword = (rule, value, callback) => {
      let checkpw = ''
      if (this.restpwVisible){
        checkpw = this.restpwForm.password
      } else if (this.registerVisible) {
        checkpw = this.registerForm.password
      }
      if (!value) {
        callback(new Error(this.$t('register.ConfirmPassword')))
      } else if (checkpw && checkpw !== value) {
        callback(new Error(this.$t('register.EnterPasswordNotMatch')))
      } else {
        callback()
      }
    }

    // 校验隐私协议是否勾选
    const validatePrivacy = (rule, value, callback) => {
      if (value === true) {
        callback()
      } else {
        callback(new Error(this.$t('login.CheckPrivacyPolicy')))
      }
    }

    // 公共检验数据rule
    const account = [
      { required: true, get message() { return _this.$t('register.EnterYourPhoneMumber') }, trigger: 'blur' },
      { pattern: /^\d{11}$/, get message() { return _this.$t('login.PhonenumberNotValid') }, trigger: 'blur' },
      { validator: validateAccount, trigger: 'change' }
    ]
    const code = [
      { required: true, get message() { return _this.$t('register.EnterVerificationCode') }, trigger: 'blur' },
      { validator: validateCode, trigger: 'change' }
    ]
    const password = [
      { required: true, get message() { return _this.$t('register.EnterPassword') }, trigger: 'blur' },
      { min: 6, get message() { return _this.$t('login.PasswordLess6Char') }, trigger: ['change', 'blur'] },
      { max: 18, get message() { return _this.$t('login.PasswordMore18Char') }, trigger: ['change', 'blur'] },
      { pattern: /^[a-zA-Z0-9@_=]+$/, get message() { return _this.$t('login.PasswordFormat') }, trigger: ['change', 'blur'] },
    ]
    const checkPassword = [
      { required: true, get message() { return _this.$t('register.ConfirmPassword') }, trigger: 'blur' },
      { validator: validateCheckPassword, trigger: ['change', 'blur'] }
    ]

    const _this = this
    return {
      oauthThirdParty: [{ id: 1, name: '飞象互联', logo: 'https://hileia.aryun.com/oauth/feiiplat.png', url: '/feiiplat' }],
      LANGUAGE: LANGUAGE,
      language: '',
      account: '',
      password: '',
      privacy: false, // login privacy
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
      accountSts: 'success',
      accountHelp: '',
      pwdSts: 'success',
      pwdHelp: '',
      redirect: undefined,

      oauthRedirectData: null,
      oauthModalVisible: true,

      // 注册
      registerVisible: false,
      registerForm: {
        userName: '',
        account: '',
        code: '',
        password: '',
        checkPassword: '',
        privacy: false
      },
      registerRules: {
        account,
        userName: [
          { required: true, get message() { return _this.$t('register.EnterUsername') }, trigger: 'blur' },
          { validator: validateUserName, trigger: ['change', 'blur'] }
        ],
        code,
        password,
        checkPassword,
        privacy: [{ validator: validatePrivacy, trigger: 'change' }]
      },
      // 忘记密码
      forgotpwVisible: false,
      forgotpwForm: {
        account: '',
        code: ''
      },
      forgotpwRules: {
        account,
        code,
      },
      // 重置密码
      restpwVisible: false,
      restpwForm: {
        password: '',
        checkPassword: '',
      },
      restpwRules: {
        password,
        checkPassword,
      },

      registerLayout: {
        labelCol: { span: 0 }
      },
      codeButtonVisible: true, // 是否展示获取验证码按钮
      codeRestSecond: 60, // 验证码冷却时间
      codeError: false, // 服务端是否报验证码错误
      accountError: false, // 服务端是否报手机号错误
      userNameError: false, // 服务端是否报姓名错误
      imageCodeModalVisible: false, // 图形验证码弹窗是否展示
      imageCode: '', // 图形验证码
      imageCodeUrl: '', // 图形验证码图片地址
      imageCodeKey: '', // 图形验证码key
      imageError: false, // 服务端是否报图形验证码错误
      registerSuccessVisible: false, // 注册成功的弹窗是否展示
      successRestSecond: 3, // 倒计时跳转到登录页
      restpwSuccessVisible: false, // 重置密码成功的弹窗是否展示
      restpwCodeKey: '', // 重置密码的短信KEY
      submitBtnDisabled: false
    }
  },
  computed: {
    // ...mapState('oauth', ['oauthThirdParty']),
    disabled() {
      return (!this.account || !this.password || !this.privacy) || this.submitBtnDisabled
    },
    routeQuery() {
      return this.$route.query
    },
    canRegister () { // 是否能点击注册按钮
      // 除了协议其他都填了就开放点击
      for (const key in this.registerForm) {
        if (key !== 'privacy' && !this.registerForm[key]) return true
      }
      return false
    },
    canForgotpw () {
      return Object.keys(this.forgotpwForm).reduce((a, b) => !(this.forgotpwForm[a] && this.forgotpwForm[b]))
    },
    canRestpw () {
      return Object.keys(this.restpwForm).reduce((a, b) => !(this.restpwForm[a] && this.restpwForm[b]))
    },
    isShowLogin () {
      return !this.registerVisible && !this.forgotpwVisible && !this.restpwVisible
    }
  },
  created() {
    this.handleInitLanguage()
    this.$store.dispatch('notification/stopFetchSysNotices')
    // this.fetchOauthThirdParty({ params: { state: OAUTH_PLATFORM_TYPE } })
  },
  methods: {
    // ...mapActions('oauth', ['fetchOauthThirdParty']),
    ...mapActions(['recoverUserSession']),
    initValidate(type) {
      this[type + 'Sts'] = 'success'
      this[type + 'Help'] = ''
    },
    getBackground(url) {
      return `background-image: url(${url})`
    },
    handleSubmit() {
      this.submitBtnDisabled = true
      if (!navigator.onLine) {
        this.submitBtnDisabled = false
        return this.$message.error(this.$t('login.NetworkNotConnected'))
      }
      const { redirect, ...otherQuery } = this.routeQuery
      // const result = await axios.post(
      //   '/api/account/signin',
      //   {
      //     account: this.account,
      //     password: MD5(this.password).toString()
      //   },
      //   {
      //     params: {
      //       _id: Global.genNonce(5)
      //     },
      //     transformRequest: [function (data, headers) {
      //       // 对 data 进行任意转换处理
      //       delete headers.HiARGlassesToken
      //       data = Qs.stringify(data)
      //       return data
      //     }],
      //   }
      // )
      /**
       * 在调用云平台登录接口前需先调用登录接口(不带HiARGlassesToken的header)
       * 为了准确判断当前账号的情况
       */
      // if (result.data.retCode === 0) {
      this.$store
        .dispatch('doLogin', {
          account: this.account,
          password: MD5(this.password).toString()
        })
        .then(_ =>
          this.$router.replace({ path: redirect || '/', query: otherQuery })
        )
        .catch(err => {
          if (err.code === 50002 && err.message === this.$t('login.AccountNotExist')) {
            this.accountSts = 'error'
            this.accountHelp = this.$t('login.AccountError')
          } else if (err.code === 50006) {
            this.pwdSts = 'error'
            this.pwdHelp = this.$t('login.PasswordError')
          } else {
            this.$message.error(err.message)
          }
          console.error(err)
        }).finally(() => {
          this.submitBtnDisabled = false
        })
      // } else {
      //   this.$message.error(result.data.comment)
      // }
    },
    handleToOauth(url) {
      location.href = url
    },
    async handleOauthSuccess(all) {
      this.$ls.set(CACHE_KEY.HILEIA_USER_INFO, all, ONE_DAY_MILLSECS)
      this.recoverUserSession(all)

      this.$nextTick(() => {
        this.$router.replace({
          name: PAGE_NAME.Home,
          query: {}
        })
      })
    },

    // 重置登录表单
    resetLoginForm () {
      this.account = ''
      this.password = ''
      this.accountSts = 'success'
      this.accountHelp = ''
      this.pwdSts = 'success'
      this.pwdHelp = ''

      this.$refs.registerForm && this.$refs.registerForm.resetFields()
      this.$refs.forgotpwForm && this.$refs.forgotpwForm.resetFields()
      this.$refs.restpwForm && this.$refs.restpwForm.resetFields()
    },

    // 展示登录界面
    showLogin () {
      this.resetLoginForm()
      this.registerVisible = false
      this.forgotpwVisible = false
      this.restpwVisible = false

      this.stopCountDown()
      this.codeButtonVisible = true
    },

    // 展示注册界面
    showRegister () {
      this.resetLoginForm()
      this.registerVisible = true
      this.forgotpwVisible = false
      this.restpwVisible = false
    },

    // 展示忘记密码界面
    showForgotpw () {
      this.resetLoginForm()
      this.forgotpwVisible = true
      this.registerVisible = false
      this.restpwVisible = false

      this.accountError = ''
    },

    // 展示重置密码界面
    showRestpw () {
      this.resetLoginForm()
      this.restpwVisible = true
      this.registerVisible = false
      this.forgotpwVisible = false
    },

    // 在获取验证码之前得校验账号，然后先获取图形验证码
    beforeGetImageCode () {
      this.$refs.registerForm.validateField('account', isError => {
        if (!isError) {
          // 获取图形验证码
          this.getImageCode()
          this.imageCodeModalVisible = true
        }
      })
    },

    // 获取图形验证码
    getImageCode () {
      this.imageCode = ''
      this.imageError = false
      axios.get(apis.imageCode).then(res => {
        if (res.data?.Image) {
          this.imageCodeUrl = 'data:image/png;base64,' + res.data.Image
          this.imageCodeKey = res.data.key
        } else {
          this.imageError = this.$t('login.GetGraphicVerifyFailed')
        }
      })
    },

    // 获取手机验证码
    getCode () {
      this.imageError = ''
      const data = new FormData()
      data.append('account', this.registerForm.account)
      data.append('code', this.imageCode)
      data.append('key', this.imageCodeKey)
      getRegisterCode(data).then(() => {
        this.imageCodeModalVisible = false
        this.codeCountDown() // 获取成功开启倒计时
      }).catch(err => {
        this.imageError = err.message || this.$t('register.EnterCorrectVerificationCode')
      })
    },
    // 重置密码获取手机验证码
    getCodeOfRestpw () {
      this.accountError = ''
      this.$refs.forgotpwForm.validateField('account', isError => {
        if (!isError) {
          const d = new FormData()
          d.append('account', this.forgotpwForm.account)

          getRestpwCode(d).then(_ => {
            this.codeCountDown() // 获取成功开启倒计时
          }).catch(e => {
            this.accountError = e.message
          })
        }
      })
    },

    // 重新获取验证码倒计时
    codeCountDown () {
      this.codeButtonVisible = false
      this.codeRestSecond = 59
      codeCountDownInterval = setInterval(() => {
        this.codeRestSecond--
        if (this.codeRestSecond === 0) {
          this.stopCountDown()
          this.codeButtonVisible = true
        }
      }, 1000)
    },

    // 停止重新获取验证码的定时器
    stopCountDown () {
      if (codeCountDownInterval) {
        clearInterval(codeCountDownInterval)
        codeCountDownInterval = undefined
      }
    },

    // 提交注册
    submitRegister () {
      this.$refs.registerForm.validate(isValid => {
        if (isValid) {
          const data = new FormData()
          data.append('account', this.registerForm.account)
          data.append('code', this.registerForm.code)
          data.append('password', MD5(this.registerForm.password).toString())
          data.append('name', String(this.registerForm.userName).trim())
          registerAccount(data).then(() => {
            // 注册成功，弹出窗口
            this.showRegisterSuccess()
          }).catch(err => {
            const { code, message } = err
            switch (+code) {
              // 账号格式问题
              case 1024: {
                this.accountError = message
                this.$refs.registerForm.validateField('account')
                break
              }
              // 姓名格式问题
              case 1038: {
                this.userNameError = message
                this.$refs.registerForm.validateField('userName')
                break
              }
              // 验证码问题
              case 2002: {
                this.codeError = message
                this.$refs.registerForm.validateField('code')
                break
              }
            }
          })
        }
      })
    },

    // 提交电话号码
    submitForgotpw () {
      this.$refs.forgotpwForm.validate(isValid => {
        if (isValid) {
          const data = new FormData()
          data.append('account', this.forgotpwForm.account)
          data.append('code', this.forgotpwForm.code)

          restpwCodeKey(data).then(r => {
            this.restpwCodeKey = r.key
            this.showRestpw()
          }).catch(err => {
            this.$message.error(err.message)
          })
        }
      })
    },

    // 提交密码重置
    submitRestpw () {
      this.$refs.restpwForm.validate(isValid => {
        if (isValid) {
          const data = new FormData()
          data.append('password', MD5(this.restpwForm.password).toString())
          data.append('key', this.restpwCodeKey)

          resetpw(data).then(_ => {
            this.showRestpwSuccess()
          }).catch(err => {
            this.$message.error(err.message)
          })
        }
      })
    },

    showSuccessCore () {
      // 开启关闭弹窗倒计时
      successCountDownInterval = setInterval(() => {
        this.successRestSecond--
        if (this.successRestSecond === 0) {
          // 倒计时结束跳转到登录页
          this.fromSuccessToLogin()
        }
      }, 1000)
    },
    // 注册成功弹窗
    showRegisterSuccess () {
      this.successRestSecond = 3
      this.registerSuccessVisible = true
      this.showSuccessCore()
    },
    // 重置密码成功弹窗
    showRestpwSuccess () {
      this.successRestSecond = 3
      this.restpwSuccessVisible = true
      this.showSuccessCore()
    },

    // 取消注册成功里面的读秒倒计时
    stopSuccessCountDown () {
      if (successCountDownInterval) {
        clearInterval(successCountDownInterval)
        successCountDownInterval = undefined
      }
    },

    // 关闭注册成功弹窗并跳转登录页
    fromSuccessToLogin () {
      this.stopSuccessCountDown()
      this.registerSuccessVisible = false
      this.restpwSuccessVisible = false
      this.showLogin()
    },

    // 设定弹窗的父容器为本页面
    modalContainer () {
      return document.querySelector('.page-login')
    },

    handleChangeLanguage (v) {
      this.$store.commit('setLanguage', v)
      this.$nextTick(_ => {
        this.$message.success(this.$t('home.SetSuccessfully'))
      })
    },
    async handleInitLanguage (v) {
      this.language = this.$store.state.lang
    }
  },
  mounted() {
    lottie.loadAnimation({
      name: 'sign_in',
      container: this.$refs.animate,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: './lottie/sign_in.json'
    })
  },
  beforeDestroy() {
    lottie.destroy('sign_in')
    this.stopCountDown()
    this.stopSuccessCountDown()
  }
}
</script>

<style scoped lang="less">
.page-login {
  position: relative;
  height: 100vh;

  .common-btn {
    width: 368px;
    height: 50px;
    border-radius: 25px;
    border: none;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    background-image: linear-gradient(
      154deg,
      #236cff 0%,
      rgba(35, 108, 255, 0.8) 100%
    );
    box-shadow: 0 5px 10px 0 rgba(35, 108, 255, 0.5);
    &[disabled] {
      background: #8AB1FF;
      box-shadow: 0 5px 10px 0 rgba(35, 108, 255, 0.5);
    }
    &:hover {
      background-image: linear-gradient(154deg, #578fff 0%, #578fff 100%);
      box-shadow: 0 0 4px 4px rgba(35, 108, 255, 0.3);
    }
    &:active {
      background: #2C66DB;
      box-shadow: 0 5px 10px 0 rgba(35, 108, 255, 0.5);
    }
  }

  .left {
    position: absolute;
    top: 0;
    left: 0;
    width: 440px;
    height: 100%;
    background-color: #236cff;
    text-align: left;
    .logo {
      position: absolute;
      top: 24px;
      left: 40px;
      width: 128px;
      height: 28px;
      z-index: 1;
    }
  }
  .right {
    position: absolute;
    top: 0;
    left: 440px;
    right: 0;
    height: 100%;
    background: #f7f8fa;
    .right-container {
      position: relative;
      height: 100%;
      width: 100%;
      overflow: auto;

      .login-container {
        width: 480px;
        height: 640px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        box-shadow: 0 5px 30px 0 rgba(89, 132, 219, 0.08);
        border-radius: 16px;
        border: 1px solid #edeff2;
        box-sizing: border-box;
        padding: 66px 56px 0;
        &::v-deep input {
          height: 50px;
          font-size: 16px;
          font-weight: 400;
          color: #333;
          letter-spacing: 1px;
          background: #eff3f8;
          box-shadow: 0 0 10px 0 rgba(151, 171, 199, 0.15);
          border-radius: 8px;
          border-width: 2px;
          padding-left: 24px;
          padding-right: 24px;
          border-color: transparent;
          &:hover, &:focus {
            border-color: #236CFF;
            border-right-width: 2px !important;
          }
          &::placeholder {
            font-size: 16px;
            font-weight: 400;
            color: #6a6d73;
          }
        }
        ::v-deep .ant-input-affix-wrapper .ant-input-suffix {
          right: 24px;
        }
        .login-type {
          margin-bottom: 48px;
          &.login-title{
            display: flex;
            justify-content: space-between;
            align-items: center;
            ::v-deep .ant-select{
              height: auto;
              font-size: 16px;
              color: #6a6d73;
              .ant-select-selection,
              .ant-select-selection:focus,
              .ant-select-selection:visited,
              .ant-select-selection:active{
                border: none;
                box-shadow: none;
              }
              .ant-select-arrow{
                right: 6px;
              }
            }
          }
          div {
            height: 40px;
            font-size: 28px;
            font-weight: 500;
            color: #333333;
            line-height: 40px;
            text-align: left;
          }
        }
        .form-container {
          &::v-deep .ant-row.ant-form-item {
            margin-bottom: 32px;

            &.pwd-container {
              margin-bottom: 16px;
            }

            &.login-btn-container {
              margin-bottom: 24px
            }
          }
          &::v-deep .ant-row.ant-form-item.ant-form-item-with-help {
            margin-bottom: 0;

            &.pwd-container {
              margin-bottom: 21px;
            }
          }
          &::v-deep .has-error .ant-input {
            border-color: #fd6565;
          }
          &::v-deep div.ant-form-explain {
            text-align: left;
            font-size: 16px;
            font-weight: 400;
            color: #fd6565;
            height: 35px;
            line-height: 35px;
          }
        }
        .pwd::v-deep {
          i.anticon-eye svg {
            color: #236cff;
          }
          svg {
            width: 21px;
            height: 21px;
          }
        }
        .login-btn {
          width: 368px;
          height: 50px;
        }

        .account-control{
          display: flex;
          justify-content: space-between;
          align-content: center;
        }
        .to-forgotpw-btn{
          font-size: 16px;
          font-weight: 500;
          color: #6A6D73;
          cursor: pointer;
        }
        .to-register-btn {
          font-size: 16px;
          font-weight: 500;
          color: #236CFF;
          cursor: pointer;
        }

        &::v-deep .divider {
          margin-top: 18px;
          &::before,
          &::after {
            border-top-color: #edeff2;
          }
          span {
            font-size: 16px;
            font-weight: 400;
            color: #6a6d73;
          }
        }
        .other-login {
          display: flex;
          justify-content: center;

          .oauth-item {
            width: 42px;
            height: 42px;
            margin-right: 16px;
            background: center / cover no-repeat;
            border-radius: 50%;
            overflow: hidden;
            cursor: pointer;

            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
      .common-container{
        width: 480px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -240px;
        background: #fff;
        box-shadow: 0 5px 30px 0 rgba(89, 132, 219, 0.08);
        border-radius: 16px;
        border: 1px solid #edeff2;
        box-sizing: border-box;
        padding: 45px 56px 0;
        user-select: none;

        .main-title {
          margin-bottom: 32px;
          &.center{
            div{
              text-align: center;
            }
          }
          div {
            height: 40px;
            font-size: 28px;
            font-weight: 500;
            color: #333333;
            line-height: 40px;
          }
        }

        &::v-deep input {
          height: 50px;
          font-size: 16px;
          font-weight: 400;
          color: #333;
          letter-spacing: 1px;
          background: #eff3f8;
          box-shadow: 0 0 10px 0 rgba(151, 171, 199, 0.15);
          border-radius: 8px;
          border-width: 2px;
          padding-left: 24px;
          padding-right: 24px;
          border-color: transparent;
          &:hover, &:focus {
            border-color: #236CFF;
            border-right-width: 2px !important;
          }
          &::placeholder {
            font-size: 16px;
            font-weight: 400;
            color: #6a6d73;
          }
        }
        ::v-deep .ant-input-affix-wrapper .ant-input-suffix {
          right: 24px;
        }

        .code-operation {
          display: inline-block;
          margin-left: 22px;
          .countdown{
            display:inline-block;
            width: 43px;
            text-align: right;
            color: #236CFF;
            white-space: pre
          }
          .code-btn {
            width: 144px;
            height: 50px;
          }

          .code-tip {
            padding-left: 9px;
            font-size: 16px;
            font-weight: 500;
          }
        }

        .form-container {
          &::v-deep .ant-row.ant-form-item {
            margin-bottom: 38px;

            &.code-container .ant-input {
              letter-spacing: 12px;
              font-weight: 500;

              &::placeholder {
                letter-spacing: 0;
                font-weight: 400;
              }
            }

            &.user-name-container {
              margin-bottom: 24px;
            }

            &.privacy-container .ant-form-item-control {
              line-height: 20px;

              .to-login-btn {
                float: right;
                font-weight: 500;
                color: #236CFF;
                cursor: pointer;
              }

              .ant-checkbox+span {
                padding-left: 2px;
                padding-right: 0;
              }
            }
          }
          &::v-deep .ant-row.ant-form-item.ant-form-item-with-help {
            margin-bottom: 6px;

            &.user-name-container {
              margin-bottom: 5px;

              .ant-form-explain {
                height: 20px;
                line-height: 20px;
                transform: translateY(5px);
              }
            }

            &.privacy-container {
              margin-bottom: 4px;

              .ant-form-explain {
                transform: translateY(-2px);
              }
            }
          }
          &::v-deep .has-error .ant-input {
            border-color: #fd6565;
          }
          &::v-deep div.ant-form-explain {
            text-align: left;
            font-size: 16px;
            font-weight: 400;
            color: #fd6565;
            height: 35px;
            line-height: 35px;
            transform: translateY(3px);
          }
        }

        .pwd::v-deep {
          i.anticon-eye svg {
            color: #236cff;
          }
          svg {
            width: 21px;
            height: 21px;
          }
        }
        .register-btn {
          width: 368px;
          height: 50px;
        }
        .forgotpw-btn{
          height: 50px;
          width: 140px;
        }
      }
      .register-container {
        margin-top: -350px;
        height: 700px;
      }
      .forgotpw-container {
        margin-top: -222px;
        height: 445px;
        .main-title{
          margin-bottom: 48px;
        }
        // .ant-row.ant-form-item{
        //   margin-bottom: 40px!important;
        // }
        // .ant-row.ant-form-item:nth-child(2){
        //   margin-bottom: 48px!important;
        // }
        .common-btn{
          width: 140px;
        }
        .forgotpw-cancel-btn{
          height: 50px;
          background: #F7F8FA;
          box-shadow: 0px 6px 10px 0px rgba(207,222,241,0.7);
          border-radius: 25px;
          font-size: 16px;
          font-weight: bold;
          color: #000000;
        }
        .position{
          display:inline-block;
          text-align:center;
        }
        .info-error{
          position: absolute;
          top: 34px;
          left: 6px;
          color: #fd6565;
          font-size: 16px;
          height: 35px;
          line-height: 35px;
          transition: color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
          transform: translateY(3px);
        }
      }
      .restpw-container{
        margin-top: -220px;
        height: 441px;
      }

      @media screen and (max-height: 700px) {
        .common-container {
          top: 0;
          margin-top: 0;
        }
      }
    }
  }

  .two-buttons-one-close-confirm-modal {
    ::v-deep .custom-content {
      padding: 10px;
      margin-bottom: 0;
      position: relative;
      user-select: none;

      > h2 {
        display: block;
        width: 379px;
        margin-bottom: 82px;
        font-size: 18px;
        font-weight: 500;
        color: #000000;
        line-height: 27px;
      }

      > i {
        display: block;
        width: 22px;
        height: 22px;
        background-image: url(~@/assets/close.svg);
        background-size: 100% 100%;
        position: absolute;
        right: -8px;
        top: -6px;
        cursor: pointer;
      }

      > .basic-btn-group {
        justify-content: flex-end;

        > button {
          margin-right: 32px;

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }

  .image-code-modal {
    ::v-deep .custom-content {
      > h2 {
        margin-bottom: 30px;
      }

      .ant-input {
        height: 44px;
        font-size: 16px;
        font-weight: 400;
        color: #333;
        letter-spacing: 1px;
        background: #eff3f8;
        box-shadow: 0 0 10px 0 rgba(151, 171, 199, 0.15);
        border-radius: 8px;
        border-width: 2px;
        padding-left: 24px;
        padding-right: 24px;
        border-color: transparent;
        &:hover, &:focus {
          border-color: #236CFF;
          border-right-width: 2px !important;
        }
        &::placeholder {
          font-size: 16px;
          font-weight: 400;
          color: #6a6d73;
        }
      }

      .image-code-container {
        margin-bottom: 40px;
        display: flex;
        position: relative;
        align-items: center;

        .ant-input.image-code-input {
          width: 200px;
          letter-spacing: 12px;
          font-weight: 500;

          &::placeholder {
            letter-spacing: 0;
            font-weight: 400;
          }
        }

        .image-container {
          width: 100px;
          height: 42px;
          margin-left: 10px;
          box-shadow: 0 0 10px 0 rgba(151, 171, 199, 0.15);
          border-radius: 8px;
          border-width: 1px;
          border-color: rgb(151, 171, 199);
          overflow: hidden;

          > img {
            width: 100%;
            height: 40px;
          }
        }

        .next-image {
          margin-left: 10px;
          font-weight: 500;
          color: #236CFF;
          cursor: pointer;
        }

        .image-error {
          position: absolute;
          top: 50px;
          left: 6px;
          color: #fd6565;
        }
      }

      .image-confirm-btn {
        width: 142px;
        margin-left: 125px;
      }
    }
  }

  .image-success-modal {
    ::v-deep .custom-content {
      h2 {
        width: 100%;
        margin-bottom: 30px;
        text-align: center;
        font-size: 25px;
      }

      .tip {
        text-align: center;
        font-size: 16px;

        .seconds {
          color: rgb(35, 108, 255);
        }

        .return {
          color: #236CFF;
          font-weight: 500;
          cursor: pointer;
        }
      }
    }
  }

  // 密码重置成功的弹窗
  .passwd-rest-succ{
    ::v-deep .ant-modal-body{
      padding: 29px;
      .custom-content{
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 37px;
        font-size: 26px;
        font-weight: 600;
        color: #000000;
        .svg-icon{
          margin-right: 10px;
          font-size: 32px;
        }
      }
    }
  }
}
::v-deep .image-code-modal, ::v-deep .image-success-modal {
    .ant-modal .ant-modal-content {
      border-radius: 16px;
    }
}
</style>
